/**
 * WbalanceIcon — sanitized from `assets/newSvg/wbalance.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function WbalanceIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M6.80937,17.8436 C6.778,18.0912 6.53715,20.5727 6.5,21 C6.45312,21.5391 6.05228,22 5.5,22 C4.94771,22 4.5,21.5522 4.5,21 C4.5,20.4288 4.6163,19.3305 4.72139,18.4398 C4.9257,16.7082 5.1667,15.0135 5.70816,13.3496 C6.33265,11.4305 7.45803,8.97098 9.46454,6.96447 C13.3986,3.03043 19.1172,2.44872 19.2618,2.43416 C19.3385,2.42645 19.4974,2.41874 19.6844,2.48198 C19.8978,2.55416 20.0836,2.69913 20.2057,2.88826 C21.1973,4.37858 20.9531,6.5981 19.7386,7.89549 C19.7512,8.01579 19.7421,8.14042 19.7083,8.26411 C19.5194,8.95363 19.2753,9.67684 18.9594,10.4002 C18.4078,11.6631 17.6313,12.9399 16.5356,14.0355 C14.4856,16.0855 11.7943,17.0271 9.692,17.4663 C8.51607,17.712 7.49328,17.8071 6.80937,17.8436 Z"
        fill={color}
      />
    </Svg>
  );
}

export default WbalanceIcon;
